namespace('arctic');

compass.require('arctic.views.common.entryPage');
compass.require('arctic.views.individual.personalInfo');
compass.require('arctic.views.individual.individualPaymentRequired');
compass.require('arctic.views.gds.gdsIndividualInfo');
compass.require('arctic.views.gds.gdsGroupInfo');
compass.require('arctic.views.common.frontDesk');
compass.require('arctic.views.common.hotelInfo');
compass.require('arctic.views.common.hotels');
compass.require('arctic.views.common.testErrors');
compass.require('arctic.views.common.testBackendErrors');
compass.require('arctic.views.common.paymentSummary');
compass.require('arctic.views.common.failedCards');
compass.require('arctic.views.group.groupInfo');
compass.require('arctic.views.group.groupPaymentRequired');
compass.require('arctic.views.group.groupDemo');
compass.require('arctic.views.group.groupManage');
compass.require('arctic.views.groupLanding.groupMemberEntry');
compass.require('arctic.views.groupLanding.groupMemberRoomAssignment');
compass.require('arctic.views.groupLanding.groupMemberInfo');
compass.require('arctic.views.groupLanding.groupMemberSummary');

compass.require('compass.arctic.HeaderWidget');
compass.require('compass.arctic.NavBarWidget');
compass.require('compass.arctic.HelpWidget');
compass.require('compass.arctic.TimedOutWidget');
compass.require('compass.arctic.RefreshSessionWidget');

compass.require('compass.account.EditAccountWidget');
compass.require('compass.account.ChangePasswordWidget');

compass.requireLib('compass.util.format');

compass.log(compass.log.TRACE,'what up');


arctic.godview = function(data) {
	var me = this;/*remember the arctic.godview object as 'me'*/
	var _data = data || {};
	var d = jQuery.dom;
	var $j = jQuery;
	compass.GA.setUTMParams();
	compass.GA.setCustomVar('meeting_id', _data.meetingInfo.meeting_id.toString());

	try{
		posthog.group('meeting',_data.meetingInfo.meeting_id.toString(),
				{	name:_data.meetingInfo.name,
					account:_data.meetingInfo.accountName,
					client: _data.meetingInfo.clientName
				}
			);

		posthog.group('account',_data.meetingInfo.account_id.toString(),
				{	name:_data.meetingInfo.accountName,
					client: _data.meetingInfo.clientName
				}
			);

		posthog.group('client',_data.meetingInfo.client_id.toString(),
				{	name: _data.meetingInfo.clientName,
					client: _data.meetingInfo.clientName
				}
			);


	} catch(ex){

	}

	_data.reg = _.mapObject(_data.reg, function(val,key) {
		return decodeURIComponent(val);
	});
	_data.meetingInfo.defaultCurrencyFormatter = compass.util.currencyFormatter(_data.meetingInfo.currencyCode, {
		decimal : _data.meetingInfo.decimal_separator,
		separator : _data.meetingInfo.thousands_separator
	});

	_data.meetingInfo.defaultDateFormatter = compass.util.dateFormatter(_data.meetingInfo.datemask);
	_data.meetingInfo.defaultShortDateFormatter = compass.util.dateFormatter( data.meetingInfo.datemask.substring(0,4));

	var _timeoutHandler = (function (timeout) {
		if (timeout < 0 || window.location.hash === '#timedout') {  // If the timeout is -1, means it never times out
			return {
				reset: function () {},
				stop: function () {}
			};
		}

		timeout = timeout*1000; // convert to ms for JS
		var PRETIME = 60*5*1000;
		var timer, TIMER_LENGTH = timeout < PRETIME ? timeout/2 : (timeout - PRETIME), dialog;

		var resetTimer = function () {
			if (timer === null) { return; }
			clearTimeout(timer);
			timer = setTimeout(displayDialog, TIMER_LENGTH);
		};
		var killTimer = function () {
			clearTimeout(timer);
			timer = null;
		};
		// Will generate the confirmation dialog to extend the timeout
		var displayDialog = function () {
			timer = setTimeout(forceTimeout, timeout-TIMER_LENGTH + 100);
			var container = d.div();
			var refreshSessionWidget = new compass.arctic.RefreshSessionWidget(container);
			refreshSessionWidget.bind('refreshSession', function () {
				$j.ajax({
					type : 'POST',
					url: '/refreshSession?type=keepalive',
					success: function () {
						dialog.close();
						resetTimer();
					}
				});
			});

			dialog = d.dialog({
				classes: "refreshSession",
				contents: container
			});
		};
		// Will redirect the page when the timeout should have occurred ?
		var forceTimeout = function () {
			dialog.close();
			$j.ajax({ url: '/refreshSession?type=forceTimeout', 
				type: 'POST',
			});
		};

		timer = setTimeout(displayDialog, TIMER_LENGTH);

		return {
			reset: resetTimer,
			stop: killTimer
		};
	}(data.timeout));

	arctic.timer = _timeoutHandler;

	var _handleLogin = function (event, data) {
		var callbacks = {};
		callbacks.failedLoginFunction = data.failedLoginFunction;
		callbacks.multipleMatchesFunction = data.multipleMatchesFunction;
		callbacks.showLoginNotAllowedFunction = data.showLoginNotAllowedFunction;
		callbacks.closeLoginChoices = data.closeLoginChoices;

		delete data['multipleMatchesFunction'];
		delete data['failedLoginFunction'];
		delete data['showLoginNotAllowedFunction'];

		$j.ajax({
			url: '/login',
			type: 'POST',
			data: data,
			success: function (loginResponse) {
				compass.loading.stop();
				if (loginResponse.status === "OK") {
					_navBar.setLoggedIn(loginResponse);
					d.dialog.closeAll();
					_data.canOnlyLookupAccount = false;


					if (loginResponse.take_to_route_after_login != null
					       && loginResponse.take_to_route_after_login.length > 0){
                        if ( Backbone.history.fragment === loginResponse.take_to_route_after_login ){
                        	_app_router.navigate('__deadroute__');
                        }
						_app_router.navigate(loginResponse.take_to_route_after_login, true);
                        return;
					}

					_app_router.navigate('frontDesk', true);


				}else if (loginResponse.status === "INVALID") {
					if (callbacks.closeLoginChoices) {
						callbacks.closeLoginChoices();
					}
					callbacks.failedLoginFunction();
				}else if (loginResponse.status === "NOTALLOWED") {
					callbacks.showLoginNotAllowedFunction(loginResponse.reason);
				}else if (loginResponse.status === "MULTIPLE") {
					callbacks.multipleMatchesFunction(loginResponse.matchedArray);
				}
			}
		});
	};

	var _handleLoginOption = function(event, data) {
		var passedEvent = event;
		var loginValues = data.loginWidget.grabValues();
		var specificUser = data.loginObj;
		var callbacks = data.callbacks;

		var params = {
			// params are missing the callbacks
					password:loginValues.password,
					remember:loginValues.remember,
					failedLoginFunction: callbacks.failedLoginFunction,
					multipleMatchesFunction: callbacks.multipleMatchesFunction,
					showLoginNotAllowedFunction: callbacks.showLoginNotAllowedFunction,
					closeLoginChoices: callbacks.closeLoginChoices
			};

		var idKey = specificUser['TYPE'] == "GROUP" ? 'group_id' : 'attendance_id';

		params[idKey] = specificUser.ID;

		_handleLogin(passedEvent,params);

	};

	$('body').bind('LoginWidget.LoginAttempt', _handleLogin);
	$('body').bind('LoginOptionClicked.buttonClick', _handleLoginOption);
	$('body').bind( CompassEvents.Login, function (event, loginInfo) {
		_navBar.setLoggedIn(loginInfo);
	});

	$('body').bind(CompassEvents.SendResetPasswordEmail, function(e,data) {
		_handleSendResetPasswordEmail(data.email,data.onpeakID, data.callback);
	});

	$('body').bind(CompassEvents.ResetPassword, function(e,data) {
		_handleResetPassword(data.onpeakID,data.password,data.password_reset_code, data.meetingInfo, data.errorCallback);
	});

	var _handleSendResetPasswordEmail = function(email,onpeakID,callback) {
		$j.ajax({
			url: '/sendPasswordCodeEmail',
            type : 'POST',
			data: {email: email, onpeakID: onpeakID},
			success: function(data) {
				callback(data.success, data.hasPassword, data.errorMessage);
			}
		});
	};


	var _handleResetPassword = function(onpeakID,password,password_reset_code,meetingInfo,errorCallback) {
		$j.ajax({
			url: '/resetExternalPassword',
			type : 'POST',
			data: {onpeakID: onpeakID, password: password,password_reset_code:password_reset_code},

			success: function(data) {
				if(data.success){
					jQuery('.resetPassErrorDiv').empty();
					if(data.idType == 'attendance_id'){
						_handleLogin('',{
							meetingInfo:meetingInfo,
							attendance_id:onpeakID,
							login:data.email,
							password:password
							}
						);
					}
					if(data.idType == 'group_id'){
						_handleLogin('',{
							meetingInfo:meetingInfo,
							group_id:onpeakID,
							login:data.email,
							password:password
							}
						);

					}
				}
				else{
					// clear out the previous errors
					jQuery('.resetPassErrorDiv').empty();

					jQuery('.resetPassErrorDiv').append(d.div({className:'error'},data.errorText));

					errorCallback(data.errorMessage);
				}
			},
			error : function(data){
				errorCallback(data.errorMessage);
			}
		});
	};

	var _setCSSVariables = function(meetingCustomColors) {
		for(var colorIndex=0; colorIndex < meetingCustomColors.length; colorIndex++) {
			var code = meetingCustomColors[colorIndex].code;
			var color = meetingCustomColors[colorIndex].color;
			switch(code) {
				// TO BE RETIRED
				case 'PRIMARY_BUTTONS':
					compass.util.css.setCustomHSLByHex('customButtonColor', color);
				break;
				case 'HOTEL_CARD_HEADERS':
					compass.util.css.setCustomHSLByHex('customGalleryColor', color);
				break;
				case 'BOOKING_GRID_AND_STAY_DATES':
					compass.util.css.setCustomHSLByHex('customHotelInfoColor', color);
				break;
				case 'PERSONAL_AND_GROUP_INFO_PRIMARY_TEXT':
					compass.util.css.setCustomHSLByHex('customCheckoutColor', color);
				break;
				case 'FRONT_DESK_TILE_HEADERS':
					compass.util.css.setCustomHSLByHex('customFrontDeskColor', color);
				break;
				case 'HEADQUARTERS_HOTEL_BANNER':
					compass.util.css.setCustomHSLByHex('customHQColor', color);
				break;
				// TO BE USED GOING FORWARD
				case 'PRIMARY_TEXT':
					compass.util.css.setCustomHSLByHex('customPrimaryText', color);
				break;
				case 'MAIN_CUSTOM_COLOR':
					compass.util.css.setCustomHSLByHex('mainCustomColor', color);
				break;
				case 'BACKGROUND_TEXT':
					compass.util.css.setCustomHSLByHex('backgroundText', color);
				break;
				default:
					console.warn("Unsupported color code [" + code + "] provided.");
			}
		}
	};

	var _navBar;
	var _app_router;
	var _currentView;
	var _header;
	me.run = function() {
		me.handler = function(evt, route) {
			_app_router.navigate(route, true);
		};

		_header = new compass.arctic.HeaderWidget($j('#header'), {meetingInfo : _data.meetingInfo});

		//$j(document.body).bind('someviewfinishedLoading'){
			// headerWidget.setHeaderWidgetTextAndFocus(data.viewName)
		//}
		_setCSSVariables(_data.meetingInfo.meetingCustomColors);
		
		// Add body class for redesign
		if (compass.isRedesignEnabled()) {
			// Add class to body for CSS targeting
			$j('body').addClass('redesign-enabled');
		}
		
		if (_data.loginStatus.loggedIn) {
			_navBar = new compass.arctic.NavBarWidget($j('#navBar'), {
				meetingInfo: _data.meetingInfo,
				loginInfo: _data.loginStatus
			});
		} else {
			_navBar = new compass.arctic.NavBarWidget($j('#navBar'), {
				meetingInfo: _data.meetingInfo
			});
		}
		_navBar.bind('NavBarWidget.EditAccount', function (event) {
			$j.ajax({
				url: '/accountInfo',
				success: function (data) {
					var container = d.div();

					var editWidget = new compass.account.EditAccountWidget(container, {
						WUID: "editAccount",
						account: data
					});

					editWidget.bind(CompassEvents.UpdateAccountInfo, function (event, newData) {
						if (newData.phone === data.phone && newData.email === data.email
								&& newData.oldPassword === newData.newPassword) {
							return;
						}

						jQuery.ajax({
							url: '/updateAccount',
							type : 'POST',
							data: {
								phone: (newData.phone === data.phone) ? "" : newData.phone,
								email: (newData.email === data.email) ? "" : newData.email,
								oldPassword: newData.oldPassword,
								newPassword: newData.newPassword
							},
							success: function (data) {
								drawUpdate(data.emailChangeSuccess, data.phoneChangeSuccess);
							}
						});
					});

					var drawUpdate = function (emailSuccess, phoneSuccess) {
						var messageFlashText = {
							email: 'Email updated',
							phone: 'Phone updated',
							generic: 'Account updated'
						};

						$(document.body).find('.updateMessage').remove();

						var emailMsg = d.div({
							className: 'updateMessage'
						}, messageFlashText.email);

						var phoneMsg = d.div({
							className: 'updateMessage'
						}, messageFlashText.phone);

						var genericMsg = d.div({
							className: 'updateMessage'
						}, messageFlashText.generic);

						var msg = d.div();

						if(emailSuccess || phoneSuccess) {
							msg.append(genericMsg);
							msg.hide().insertBefore(container).fadeIn(500, function() {
								setTimeout(function () {
								dialog.close();
								}, 500);
							});
						}
					};

					var dialog = d.dialog({
						classes: "editAccount",
						contents: container,
						disableClicksOutsideModal: true
					});
				}
			});
		});
		_navBar.bind('NavBarWidget.ChangePassword', function(event, account_info) {
			var container = d.div();
			var changePasswordWidget = new compass.account.ChangePasswordWidget(container, {
				WUID: "changePassword"
			});

			changePasswordWidget.bind(CompassEvents.ChangePassword, function (event, newData) {
				jQuery.ajax({
					url: '/updateAccount',
                    type : 'POST',
					data: {
						phone: "",
						email: "",
						oldPassword: newData.oldPassword,
						newPassword: newData.newPassword
					},
					success: function (data) {
						drawUpdate(data.passwordChangeSuccess, data.passwordChangeMessage);
					}
				});
			});

			var drawUpdate = function (success, message) {
				var messageFlashText = success ? 'Updated' : message;

				$(document.body).find('.updateMessage').remove();

				var msg = d.div({
					className: 'updateMessage ' + (success ? 'passwordSuccess': 'passwordFail')
				}, messageFlashText);
				msg.hide().insertBefore(container).fadeIn(500, function () {
					if(success) {
						setTimeout(function () {
							dialog.close();
						}, 500);
					}
				});
			};

			var dialog = d.dialog({
				classes: "changePassword",
				contents: container,
				disableClicksOutsideModal: true
			});
		});
		_navBar.bind('NavBarWidget.LogOut', function (event, account_info) {
			jQuery.ajax({
				url: '/logout',
				success : function() {
					window.location = compass.rootPrefix + '/' + compass.matchDict.meetingCode;
				}
			});
		});
		_navBar.bind('NavBarWidget.DisplayHelp', function (event) {
			$j.ajax({
				url: '/accountInfo',
				success: function (accountData) {
					var container = d.div();

					var helpWidget = new compass.arctic.HelpWidget(container, {
						WUID: "helpAccount",
						account: accountData,
						meetingInfo: _data.meetingInfo,
						loginInfo: _data.loginStatus
					});

					var dialog = d.dialog({
						classes: "helpDialog",
						contents: container,
						disableClicksOutsideModal: false
					});
				}
			});
		});

		var _login = function(type, id) {
			var types = compass.types;
			var type = type || types.UNKNOWN;

			if(_currentView !== 'entry') {
				loadView('entry', arctic.views.common.entryPage, {
					meetingInfo : _data.meetingInfo,
					login : true,
					branchInfo : {
							group_id : type === types.GROUP ? id : null,
							attendance_id : type === types.ATTENDEE ? id : null,
							hotel_id : null
					}
				}, 'Login');
			}
		};

		var Arctic = Backbone.Router.extend({
			routes : {
				// TODO: Add approriate params to routes as needed

				"login" : "login",
				"login/group/:group_id" : "loginGroup",
				"login/attendee/:attendance_id" : "loginAttendee",
				"login/group/:group_id/:hotel_id" : "loginGroup",
				"login/attendee/:attendance_id/:hotel_id" : "loginAttendee",
				"reset/:clientType/:id" : "resetPassword",

				"timedout" : "timedout",

				// Hotel Gallery
				"hotels" : "hotels",
				"hotels/:noautocurtain" : "hotels",

				// Hotel Info
				"hotelInfo/:hotel_id" : "hotelInfo",
				"hotelInfo/:hotel_id/:occupancy" : "hotelInfo",
				"hotelInfo/:hotel_id/:arrive/:depart" : "hotelInfo",
				"hotelInfo/:hotel_id/:arrive/:depart/:occupancy" : "hotelInfo",

				// Hotel Info with preselected block
				"blockInfo/:hotel_id/:blocked_room_id" : "blockInfo",
				"blockInfo/:hotel_id/:blocked_room_id/:occupancy" : "blockInfo",
				"blockInfo/:hotel_id/:blocked_room_id/:arrive/:depart" : "blockInfo",
				"blockInfo/:hotel_id/:blocked_room_id/:arrive/:depart/:occupancy" : "blockInfo",

				//Common Front Desk
				"frontDesk" : "frontDesk",
				"individualPaymentRequired" : "individualPaymentRequired",

				// Individuals
				"personalInfo" : "personalInfo",

				// js errors while rendering (not including errors that happen during clicks and events)
				"testErrors" : "testErrors",
				"testErrors/:testClickEvents" : "testErrors",
				"testBackendErrors" : "testBackendErrors",
				"testBackendErrors/:testWebServices" : "testBackendErrors",

				// GDS
				"gdsIndividualInfo" : "GDSIndividualInfo",
				"gdsGroupInfo" : "GDSGroupInfo",

				// Compass direct
				"compassDirectIndividualInfo" : "CompassDirectIndividualInfo",

				// Groups
				"groupInfo" : "groupInfo",
				"groupManage" : "groupManage",
				"groupDemo" : "groupDemo", // this is groupInfo when no rooms are being booked.
				"groupPaymentRequired" : "groupPaymentRequired",

				// Group Landing
				"groupMemberEntry/:group_id" : "groupMemberEntry",
				"groupMemberRoomAssignment" : "groupMemberRoomAssignment",
				"groupMemberInfo/:blocked_room_id/:arrive/:depart" : "groupMemberInfo",
				"groupMemberSummary" : "groupMemberSummary",

				// Magnet entry
				"magnet/:hotel_id" : "magnet",
				"magnet/:hotel_id/:category_id" : "magnet",
				"magnet/:hotel_id/:arrive/:depart": "magnetArriveDepart",
				"magnet/:hotel_id/:arrive/:depart/:category_id": "magnetArriveDepart",
				"transfer" : "transfer",
				"transfer/:hotel_id" : "transfer",
				"transfer/:hotel_id/:arrive/:depart" : "transfer",
				"email/:category_id" : "email",

				// Charging
				"paymentSummary" : "paymentSummary",
				"failedCards" : "failedCards",

				// Default route
				"search" : "entry",
				"*actions" : "entry"
			},

			magnet : function(hotel_id,category_id) {
				compass.trackPageView('MagnetEntry');


				if ( hotel_id === "0" && !category_id ){
					loadView('entry', arctic.views.common.entryPage, {
						meetingInfo: _data.meetingInfo
					}, 'Entry');
				}
				else if ( hotel_id === "0" && category_id ){
					loadView('hotels', arctic.views.common.hotels, {
						meetingInfo: _data.meetingInfo
					}, 'Entry');
				}
				else if (category_id) {
					loadView('hotelInfo', arctic.views.common.hotelInfo, {
						hotelId: hotel_id,
						meetingInfo: _data.meetingInfo
					});
				} else {
					loadView('entry', arctic.views.common.entryPage, {
						initialHotel: hotel_id,
						meetingInfo: _data.meetingInfo
					}, 'Entry');
				}
			},

			magnetArriveDepart : function(hotel_id,arrive,depart,category_id) {
				compass.trackPageView('MagnetEntry');

				var opts = {
						meetingInfo: _data.meetingInfo
					};

				if (hotel_id !== "0")
				{
					opts.initialHotel = hotel_id;
					opts.hotelId = hotel_id;
				}
				if (arrive){ opts.arrive = arrive; }
				if (depart){ opts.depart = depart; }

				var __view_name__ = 'hotelInfo';
				var __view_entry__ = arctic.views.common.hotelInfo;

				if (category_id == null){
					__view_name = "entry";
					__view_entry__ = arctic.views.common.entryPage;
				}
				else if (hotel_id === "0"){
					__view_name = "hotels";
					__view_entry__ = arctic.views.common.hotels;
				}

				loadView(__view_name__, __view_entry__, opts, 'Entry');
			},

			transfer : function(hotel_id, arrive, depart) {
				compass.trackPageView('MagnetEntry');

				if(hotel_id && hotel_id !== "0") {
					var opts = {
							hotelId : hotel_id,
							meetingInfo: _data.meetingInfo
						};

					if (arrive){opts.arrive = arrive; }
					if (depart){opts.depart = depart; }

					loadView('hotelInfo', arctic.views.common.hotelInfo, opts);
				} else {
					var opts = {meetingInfo: _data.meetingInfo};

					if (arrive){opts.arrive = arrive; }
					if (depart){opts.depart = depart; }

					loadView('hotels', arctic.views.common.hotels, opts, 'GalleryView');
				}
			},

			email :  function(category_id) {
				if(category_id){
					loadView('hotels', arctic.views.common.hotels, {
						meetingInfo: _data.meetingInfo
					}, arctic.events.HOTEL_GRID_GALLERY);
				} else {
					loadView('entry', arctic.views.common.entryPage, {
						meetingInfo: _data.meetingInfo
					}, arctic.events.ENTRY);
				}
			},

			entry : function(actions) {
				loadView('entry', arctic.views.common.entryPage, {
					meetingInfo: _data.meetingInfo
				}, 'Entry');
			},

			hotels : function(noAutoCurtain) {
				loadView('hotels', arctic.views.common.hotels, {
					meetingInfo: _data.meetingInfo, noAutoCurtain : noAutoCurtain
				}, 'GalleryView', true);
			},

			testErrors : function(testClickEvents) {
				loadView('testErrors', arctic.views.common.testErrors, {
					meetingInfo : _data.meetingInfo,
					testClickEvents : testClickEvents
				}, 'testErrors', false);
			},

			testBackendErrors : function(testWebServices) {
				loadView('testBackendErrors', arctic.views.common.testBackendErrors, {
					meetingInfo: _data.meetingInfo,
					testWebServices : testWebServices
				}, 'testBackendErrors', false);
			},

			blockInfo : function(hotelId, blockedRoomId, arrive, depart, occupancy) {
				occupancy = depart ? occupancy : arrive; // set occupancy to arrive if no depart (this is the blockInfo/:hotel_id/:blocked_room_id/:occupancy route)
				loadView('hotelInfo', arctic.views.common.hotelInfo, {
					hotelId : hotelId,
					blockedRoomId : blockedRoomId || undefined,
					arrive: arrive || undefined,
					depart: depart || undefined,
					occupancy: occupancy || undefined,
					meetingInfo: _data.meetingInfo
				});
			},

			hotelInfo : function(hotelId, arrive, depart, occupancy) {
				occupancy = depart ? occupancy : arrive; // set occupancy to arrive if no depart (this is the hotelInfo/:hotel_id/:occupancy route)

				loadView('hotelInfo', arctic.views.common.hotelInfo, {
					hotelId : hotelId,
					arrive: arrive || undefined,
					depart: depart || undefined,
					occupancy: occupancy || undefined,
					meetingInfo: _data.meetingInfo
				});
			},

			resetPassword : function(type,id) {
				loadView('entry', arctic.views.common.entryPage, {
					meetingInfo: _data.meetingInfo,
					showResetForm: true,
					clientId: id,
					clientType: type
				}, 'Entry');
			},

			loginGroup:function(group_id){_login(compass.types.GROUP,group_id);},
			loginAttendee:function(attendance_id){_login(compass.types.ATTENDEE,attendance_id);},

			login: _login,

			timedout : function() {
				arctic.timer.stop();
				var timedOutWidget = new compass.arctic.TimedOutWidget($j('#mainbody'), {
					WUID : 'TimedOutWidget'
				});
				timedOutWidget.bind(CompassEvents.TimedOut, function(event) {
					window.location = compass.rootPrefix + '/' +  compass.matchDict.meetingCode;
				});
			},

			personalInfo : function() {
				loadView('pInfo', arctic.views.individual.personalInfo, {
					meetingInfo : _data.meetingInfo,
					regData: _data.reg
				}, 'PersonalInfo');
			},

			individualPaymentRequired : function() {
				loadView('individualPaymentRequired', arctic.views.individual.individualPaymentRequired, {
					meetingInfo : _data.meetingInfo
				}, 'IndividualPaymentRequired');
			},

			GDSIndividualInfo: function () {
				loadView('gdsIndiv', arctic.views.gds.gdsIndividualInfo, {
					meetingInfo: _data.meetingInfo,
					regData: _data.reg
				});
			},

			GDSGroupInfo: function () {
				loadView('gdsGroup', arctic.views.gds.gdsGroupInfo, {
					meetingInfo: _data.meetingInfo,
					regData: _data.reg
				}, 'GdsGroup');
			},

			CompassDirectIndividualInfo: function () {
				// EAN-712 This route is currently identical to GDSIndividualInfo and will be replaced during PSD2 implementation -AD
				loadView('cdIndiv', arctic.views.gds.compassDirectIndividualInfo, {
					meetingInfo: _data.meetingInfo,
					regData: _data.reg
				}, 'ExpediaIndividual');
			},

			frontDesk : function() {
				loadView('frontDesk', arctic.views.common.frontDesk, {
					meetingInfo : _data.meetingInfo
				});
			},

			groupInfo : function() {
				loadView('groupInfo', arctic.views.group.groupInfo, {
					meetingInfo : _data.meetingInfo,
					regData: _data.reg
				}, 'GroupManagerPersonalInfo');
			},

			groupPaymentRequired : function() {
				loadView('groupPaymentRequired', arctic.views.group.groupPaymentRequired, {
					meetingInfo : _data.meetingInfo
				}, 'groupPaymentRequired');
			},

			groupDemo : function() {
					loadView('groupInfo', arctic.views.group.groupDemo, {
							meetingInfo : _data.meetingInfo
					}, 'GroupManagerDemo');
			},

			groupMemberInfo : function(blocked_room_id,arrive, depart) {
				loadView('groupMemberInfo', arctic.views.groupLanding.groupMemberInfo, {
					meetingInfo : _data.meetingInfo,
					blocked_room_id : blocked_room_id,
					arrive : arrive,
					depart : depart
				}, 'RsvpPersonalInfo');
			},

			groupManage : function() {
				loadView('groupManage', arctic.views.group.groupManage, {
					meetingInfo : _data.meetingInfo
				}, 'GroupManage');
			},
			/* rsvp routes */
			groupMemberEntry : function(group_id) {
				loadView('groupMemberEntry', arctic.views.groupLanding.groupMemberEntry, {
					group_id : group_id,
					meetingInfo : _data.meetingInfo
				}, 'RsvpLandingPage');
			},

			groupMemberRoomAssignment : function() {
				loadView('groupMemberRoomAssignment', arctic.views.groupLanding.groupMemberRoomAssignment, {
					meetingInfo : _data.meetingInfo
				}, 'RsvpHotelSelection');
			},

			groupMemberSummary : function() {
				loadView('groupMemberSummary', arctic.views.groupLanding.groupMemberSummary,{}, 'RsvpFrontDesk');
			},

			paymentSummary : function() {
				loadView('paymentSummary', arctic.views.common.paymentSummary, {
					meetingInfo : _data.meetingInfo
				});
			},
			failedCards : function() {
				loadView('failedCards', arctic.views.common.failedCards, {
					meetingInfo : _data.meetingInfo
				});
			}
		});

		var _viewCache = { };

		var _loadView =  function(name, constructor, options, evt, cacheable) {
			var viewport = $j('#viewport');
			var viewContainer = viewport.children().first().detach();
			viewport.empty();
            var hash = window.location.hash || '';
            hash = hash.split('/')[0].replace('#', '');

            if ( _data.canOnlyLookupAccount ){
                if ( _.contains(['entry'], name)){
                    if ( !_.contains(['reset','login','groupMemberEntry'], hash )){
                    	if ( options.meetingInfo.queueItLink.length > 0 ){
                    		window.location = options.meetingInfo.queueItLink;
                    	} else {
                    		window.location = "/e/" + options.meetingInfo.meetingCode;
                    	}
                    }
                }
                else{
                	if ( !_.contains(['login','groupMemberEntry'], hash )){
                		if ( options.meetingInfo.queueItLink.length > 0 ){
                    		window.location = options.meetingInfo.queueItLink;
                    	} else {
                    		window.location = "/e/" + options.meetingInfo.meetingCode;
                    	}

                    }
                }
            }

			$('html').attr('class', 'view-' + name);

			var cached = _viewCache[name];
			if(cached) {
				viewport.append(cached);
			} else {
				var viewDiv = d.div({ className : name + 'View .viewContainer' });
				d.dialog.closeAll();
				d.alert.closeAll();
				viewport.append(viewDiv);

				var view = new constructor(viewDiv, options);
				var renderComplete = function() {
					if(evt) { compass.trackPageView(evt); }
					viewport.append(d.div({ className : name + 'ViewRenderComplete' }));
				};
				view.run(renderComplete);

				if(cacheable) {
					_viewCache[name] = viewDiv;
				}
			}

			_currentView = name;
		};

		// re-throw in javascript doesn't work very well...so need to branch.
		var loadView = function(name, constructor, options, evt, cacheable) {
			if (!arctic.handleErrors) {
				_loadView(name, constructor, options, evt, cacheable);
			} else {
				try {
					_loadView(name, constructor, options, evt, cacheable);
				} catch(ex){
					var bd = jQuery('#mainbody');
					bd.empty();
					compass.handleException(ex);
				}
			}
		};

		// modify the route, used to allow back buttoning in the curtain.
		var modifyRoute = function(evt, name){
			_app_router.navigate(name);
		};

		jQuery('body').bind(CompassEvents.ModifyRoute, modifyRoute);

		// Initiate the router
		_app_router = new Arctic();
		// Start Backbone history a neccesary step for bookmarkable URL's
		Backbone.history.start();

		// Add navigation handlers and prepare the header widget
		var viewport = $j('#viewport');
		viewport.bind(CompassEvents.ViewLoaded, function(evt, headerDescription){_header.setHeaderDescription(headerDescription);});
		viewport.bind(CompassEvents.Navigate, me.handler);
		viewport.bind(CompassEvents.InvalidateView, function(evt, viewName) {
			_viewCache[viewName] = undefined;
		});
	};
};

arctic.events = {
	TRACK_PAGE_VIEW : 'arctic.ux.TrackPageView',
	TRACK_EVENT : 'arctic.ux.TrackEvent'
};

(function() {
	function trackEvent(e, data) {
		var eventName = data.eventName;
		var data = _.keys(data).length > 1 ? JSON.stringify(data) : undefined;
		jQuery.ajax({
			url : '/trackPageView',
			type : 'POST',
			ignoreTimeout : true,
			data :  {
				eventData : JSON.stringify({
					eventName : eventName,
					arcticEvent : data
				})
			}
		});
	}

	function trackPageView(e, data) {
		compass.GA.trackPageView(compass.rootPrefix.replace('/', '') + '/' + data.eventName);
		trackEvent(e, data);
	}

	compass.bindToEvent('arctic.ux.TrackEvent', trackEvent);
	compass.bindToEvent('arctic.ux.TrackPageView', trackPageView);
})();

compass.trackPageView = function(viewName) {
	compass.fireEvent(arctic.events.TRACK_PAGE_VIEW, { eventName : viewName });
};

compass.trackEvent = function(eventName, data) {
	var data = jQuery.extend({ }, data, { eventName : eventName });
	compass.fireEvent(arctic.events.TRACK_EVENT, data);
};
